// EMİR #77 — YASAL METİN TASLAKLARI (TR; robot-taslak, owner-onay bekliyor).
//
// ⚠️ TASLAK UYARISI: Bu metinler standart-uygulama diliyle, dürüst ve sade
// yazılmış TASLAKLARDIR. HUKUKİ KESİNLİK İDDİA ETMEZ. Yürürlüğe girmeden önce
// owner tarafından onaylanmalı; [OWNER: ...] placeholder'ları doldurulmalı.
// Veri envanteri KODDAN çıkarılmıştır (auth.ts profil şeması, consent.ts ipHash,
// FCM token, opt-in konum, cihaz parmak izi, alt-işleyiciler).
//
// Kaynak eşleşmeleri: rıza akışı ConsentSheet.tsx (PRIVACY_URL/TERMS_URL) +
// CookieConsentBanner.tsx (COOKIE_POLICY_URL) bu sayfalara bağlanır (404 onarımı).

export interface LegalSection { h: string; body: string[] }
export interface LegalDoc {
  slug: string;
  title: string;
  updated: string;   // "Yürürlük: [owner onay tarihi]" — onaylanınca doldurulur
  intro?: string;
  sections: LegalSection[];
  draftNote?: boolean; // true → sayfada "taslak" uyarı bandı gösterilir
}

const OWNER_ORG = "[OWNER: Ticari unvan / ad-soyad]";
const OWNER_ADDR = "[OWNER: Açık adres]";
const OWNER_MERSIS = "[OWNER: MERSİS No / vergi kimlik]";
const CONTACT_EMAIL = "info@mylasa.app";
const EFFECTIVE = "[OWNER onay tarihi]";

// ── a) KVKK AYDINLATMA + b) Açık Rıza özeti → /gizlilik-politikasi ──────────
const PRIVACY: LegalDoc = {
  slug: "gizlilik-politikasi",
  title: "Gizlilik Politikası ve KVKK Aydınlatma Metni",
  updated: EFFECTIVE,
  draftNote: true,
  intro:
    "MyLASA olarak kişisel verilerinizin gizliliğine önem veriyoruz. Bu metin, 6698 " +
    "sayılı Kişisel Verilerin Korunması Kanunu (KVKK) kapsamında hangi verileri, hangi " +
    "amaçla işlediğimizi ve haklarınızı açıklar.",
  sections: [
    { h: "1. Veri Sorumlusu", body: [
      `Veri sorumlusu: ${OWNER_ORG}.`,
      `Adres: ${OWNER_ADDR}.`,
      `MERSİS/Vergi: ${OWNER_MERSIS}.`,
      `İletişim: ${CONTACT_EMAIL}.`,
    ] },
    { h: "2. İşlenen Kişisel Veriler", body: [
      "• Kimlik ve iletişim: e-posta adresi, kullanıcı adı, görünen ad.",
      "• Profil: profil fotoğrafı, biyografi, bağlantılar, ilgi alanları (isteğe bağlı).",
      "• Yaş doğrulama: doğum tarihi (yalnızca 13+ yaş kontrolü için; profilde gizli tutulur).",
      "• İçerik: paylaştığınız gönderiler, klipler, yorumlar, puanlamalar (5★).",
      "• Konum: YALNIZCA açık izin verirseniz, yaklaşık (geohash) konum — harita ve yerele-demirli keşif için. İzni istediğiniz an kapatabilirsiniz.",
      "• Teknik: cihaz/tarayıcı bilgisi, çerezler, bildirim (FCM) jetonu, kısıtlı cihaz parmak-izi (sahte hesap önleme).",
      "• Rıza kaydı: onay sürümü, onay zamanı, IP adresinin geri-döndürülemez özeti (ham IP SAKLANMAZ) ve tarayıcı bilgisi.",
    ] },
    { h: "3. İşleme Amaçları", body: [
      "• Hesabınızı oluşturmak ve hizmeti sunmak;",
      "• İçeriği yerele-demirli olarak keşfedilebilir kılmak (isteğe bağlı konum);",
      "• Güvenlik, kötüye kullanım ve sahte hesap önleme;",
      "• Yasal yükümlülükler (ör. içerik-şikâyet ve saklama süreçleri);",
      "• Size bildirim göndermek (izin verdiyseniz).",
    ] },
    { h: "4. Hukuki Sebepler", body: [
      "Verileriniz; sözleşmenin kurulması/ifası, meşru menfaat, yasal yükümlülük ve — " +
      "konum/çerez/bildirim gibi durumlarda — AÇIK RIZANIZ hukuki sebeplerine dayanılarak işlenir.",
    ] },
    { h: "5. Yurt Dışına Aktarım ve Alt İşleyiciler", body: [
      "Hizmet altyapısı bulut sağlayıcılar üzerinde çalışır; bu kapsamda verileriniz " +
      "aşağıdaki alt işleyicilere aktarılabilir:",
      "• Google / Firebase (kimlik doğrulama, veritabanı, depolama, sunucu fonksiyonları, bildirim) — sunucular AB/ABD;",
      "• Cloudflare (medya dağıtımı/depolama) — küresel CDN;",
      "• OpenAI (yüklediğiniz videoların ses-metnini çıkarma/altyazı) — ses verisi bu amaçla iletilir;",
      "• Google Cloud Run (video işleme).",
      "Aktarımlar KVKK md.9 çerçevesinde ve açık rızanız/başkaca hukuki sebeplerle yapılır.",
    ] },
    { h: "6. Saklama Süresi", body: [
      "Verileriniz, hesabınız açık olduğu sürece ve ilgili yasal saklama süreleri boyunca " +
      "saklanır. Hesabınızı sildiğinizde verileriniz makul süre içinde silinir veya anonimleştirilir " +
      "(yasal saklama gerektiren kayıtlar hariç).",
    ] },
    { h: "7. Haklarınız (KVKK md. 11)", body: [
      "Verilerinize erişme, düzeltme, silme, işlemeye itiraz ve veri taşınabilirliği haklarına " +
      `sahipsiniz. Uygulama içinde "Verilerimi İndir" ve "Hesabımı Sil" seçenekleri mevcuttur. ` +
      `Talepleriniz için: ${CONTACT_EMAIL}.`,
    ] },
    { h: "8. Açık Rıza Beyanı", body: [
      "Kayıt sırasında onayladığınız açık rıza; bu Gizlilik Politikası ve Kullanım Koşulları'nı " +
      "okuduğunuzu ve konum/çerez/bildirim gibi isteğe bağlı işlemeler için verdiğiniz izinleri kapsar. " +
      "Rızanızı dilediğiniz an geri alabilirsiniz (ilgili özelliği kapatarak veya hesabınızı silerek).",
    ] },
    { h: "9. Güvenlik ve Çocukların Korunması", body: [
      "MyLASA 13 yaş ve üzeri içindir. Yüklenen görsellerden konum (EXIF/GPS) verisi otomatik " +
      "temizlenir. Çocukların cinsel istismarına yönelik içerik (CSAM) kesinlikle yasaktır; " +
      "tespit edilen içerik kaldırılır ve yasal mercilere bildirilir (bkz. Topluluk Kuralları).",
    ] },
  ],
};

// ── c) ÇEREZ POLİTİKASI → /cerez-politikasi ─────────────────────────────────
const COOKIES: LegalDoc = {
  slug: "cerez-politikasi",
  title: "Çerez Politikası",
  updated: EFFECTIVE,
  draftNote: true,
  intro: "Bu politika, MyLASA'da çerezlerin ve benzeri teknolojilerin nasıl kullanıldığını açıklar.",
  sections: [
    { h: "1. Çerez Nedir?", body: [
      "Çerezler, ziyaret ettiğiniz siteler tarafından cihazınıza kaydedilen küçük dosyalardır. " +
      "MyLASA benzer amaçlarla tarayıcı yerel depolamasını (localStorage) da kullanır.",
    ] },
    { h: "2. Kullandığımız Çerez Türleri", body: [
      "• Zorunlu: oturum, güvenlik ve tercihlerinizin (ör. tema, çerez kararı) hatırlanması için — bunlar olmadan hizmet çalışmaz.",
      "• Analitik (isteğe bağlı): hizmeti iyileştirmek için özet kullanım verisi; yalnızca onay verirseniz.",
    ] },
    { h: "3. Onay ve Yönetim", body: [
      "İlk girişte çerez tercihinizi sorarız. Kararınızı tarayıcı ayarlarından veya uygulama içinden " +
      "değiştirebilirsiniz. Zorunlu çerezler hizmetin işleyişi için gereklidir.",
    ] },
    { h: "4. Üçüncü Taraflar", body: [
      "Medya dağıtımı (Cloudflare) ve altyapı (Google/Firebase) gibi hizmetler kendi teknik " +
      "çerezlerini kullanabilir. Ayrıntı için Gizlilik Politikası'na bakınız.",
    ] },
  ],
};

// ── d) KULLANIM KOŞULLARI (+ g CSAM cümlesi) → /kullanim-kosullari ───────────
const TERMS: LegalDoc = {
  slug: "kullanim-kosullari",
  title: "Kullanım Koşulları",
  updated: EFFECTIVE,
  draftNote: true,
  intro: "MyLASA'yı kullanarak bu Kullanım Koşulları'nı kabul etmiş olursunuz. Lütfen dikkatle okuyun.",
  sections: [
    { h: "1. Hizmet", body: [
      "MyLASA; içerik üretip paylaştığınız, kaliteyi 5★ ile puanladığınız, yerele-demirli bir " +
      "sosyal itibar ağıdır.",
    ] },
    { h: "2. Yaş Şartı", body: [
      "MyLASA'yı kullanmak için EN AZ 13 yaşında olmalısınız. Kayıt olarak 13 yaş ve üzeri " +
      "olduğunuzu beyan edersiniz. 13 yaşından küçük olduğu tespit edilen hesaplar kapatılır.",
    ] },
    { h: "3. Hesabınız", body: [
      "Hesap bilgilerinizin gizliliğinden ve hesabınız altındaki etkinlikten siz sorumlusunuz. " +
      "Doğru bilgi vermeyi ve başkasının kimliğine bürünmemeyi kabul edersiniz.",
    ] },
    { h: "4. İçerik ve Lisans", body: [
      "Paylaştığınız içeriğin haklarına sahip olduğunuzu ya da gerekli izinleri aldığınızı beyan " +
      "edersiniz. İçeriğiniz size aittir; ancak hizmeti sunabilmemiz için MyLASA'ya, içeriğinizi " +
      "platformda barındırmak, göstermek ve dağıtmak üzere dünya çapında, telifsiz, sınırlı bir " +
      "kullanım lisansı verirsiniz. Bu lisans, içeriğinizi sildiğinizde (teknik önbellek/yedek " +
      "süreleri saklı kalmak üzere) sona erer.",
    ] },
    { h: "5. MyCards (Kart Ekonomisi)", body: [
      "MyCards V1'de kartlar YALNIZCA kazanılır ve sergilenir. Kartların GERÇEK PARA DEĞERİ YOKTUR; " +
      "alınıp satılamaz, takas edilemez, para karşılığı sunulmaz. Kutu açımı bir şans oyunu/kumar " +
      "DEĞİLDİR ve para ile şans satın alınamaz. Bu bir kozmetik koleksiyon/itibar özelliğidir.",
    ] },
    { h: "6. Yasak Davranışlar", body: [
      "Yasa dışı, taciz edici, nefret içeren, şiddet öven veya cinsel istismar içeren içerik " +
      "paylaşmak; spam, sahte hesap, otomatik kötüye kullanım ve başkalarının haklarını ihlal " +
      "kesinlikle yasaktır. Ayrıntı için Topluluk Kuralları'na bakınız.",
    ] },
    { h: "7. İçerik Denetimi ve CSAM", body: [
      "Çocukların cinsel istismarına yönelik içeriğe (CSAM) SIFIR TOLERANS uygulanır. Bu tür içerik " +
      "kaldırılır, hesap kapatılır ve yasal mercilere bildirilir. İçerikleri bildirmek için uygulama " +
      "içindeki 'Bildir' aracını kullanabilirsiniz; şikâyetler makul sürede değerlendirilir.",
    ] },
    { h: "8. Askıya Alma ve Fesih", body: [
      "Bu koşulları veya Topluluk Kuralları'nı ihlal eden hesapları uyarma, içeriği kaldırma, " +
      "askıya alma veya kapatma hakkımız saklıdır. Hesabınızı dilediğiniz an kapatabilirsiniz.",
    ] },
    { h: "9. Sorumluluğun Sınırı", body: [
      "Hizmet 'olduğu gibi' sunulur. Uygulanabilir yasaların izin verdiği ölçüde, dolaylı zararlardan " +
      "sorumlu değiliz. Bu, yasal haklarınızı ortadan kaldırmaz.",
    ] },
    { h: "10. Değişiklikler ve İletişim", body: [
      "Bu koşulları güncelleyebiliriz; önemli değişiklikleri uygun şekilde bildiririz. " +
      `Sorularınız için: ${CONTACT_EMAIL}.`,
    ] },
  ],
};

// ── e) TOPLULUK KURALLARI (+ g CSAM) → /topluluk-kurallari ───────────────────
const COMMUNITY: LegalDoc = {
  slug: "topluluk-kurallari",
  title: "Topluluk Kuralları",
  updated: EFFECTIVE,
  draftNote: true,
  intro:
    "MyLASA; kalitenin değer gördüğü, güvenli ve saygılı bir topluluktur. Aşağıdaki içerik ve " +
    "davranışlar yasaktır ve bildirildiğinde değerlendirilir.",
  sections: [
    { h: "Yasak İçerik ve Davranışlar", body: [
      "• Spam / rahatsız edici davranış.",
      "• Taciz / hakaret.",
      "• Nefret söylemi.",
      "• Cinsel içerik (rıza dışı veya uygunsuz).",
      "• Şiddet öven/teşvik eden içerik.",
      "• Yasa dışı içerik.",
      "• Sahte hesap / kimliğe bürünme.",
      "• Genel olarak uygunsuz içerik.",
    ] },
    { h: "Çocuk Güvenliği (CSAM)", body: [
      "Çocukların cinsel istismarına yönelik içeriğe SIFIR TOLERANS. Böyle içerik kaldırılır, " +
      "hesap kapatılır ve yürürlükteki mevzuat uyarınca yasal mercilere bildirilir.",
    ] },
    { h: "Bildirim ve Yaptırım", body: [
      "Herhangi bir içeriği veya hesabı uygulama içindeki 'Bildir' aracıyla bildirebilirsiniz. " +
      "Bildirimler değerlendirilir; ihlallerde içerik kaldırma, uyarı, askıya alma veya hesap " +
      "kapatma uygulanabilir. Amacımız topluluğu güvende tutmaktır.",
    ] },
  ],
};

// ── f) İLETİŞİM / YER SAĞLAYICI (5651) → /iletisim ──────────────────────────
const CONTACT: LegalDoc = {
  slug: "iletisim",
  title: "İletişim ve Yer Sağlayıcı Bilgileri",
  updated: EFFECTIVE,
  draftNote: true,
  intro: "5651 sayılı Kanun kapsamında yer sağlayıcı ve iletişim bilgileri aşağıda yer alır.",
  sections: [
    { h: "Yer Sağlayıcı / İşletmeci", body: [
      `Unvan / Ad: ${OWNER_ORG}.`,
      `Adres: ${OWNER_ADDR}.`,
      `MERSİS / Vergi No: ${OWNER_MERSIS}.`,
    ] },
    { h: "İletişim", body: [
      `E-posta: ${CONTACT_EMAIL}.`,
      "İçerik şikâyetleri ve yasal bildirimler bu adres üzerinden iletilebilir; başvurular makul " +
      "sürede (hedef: 2 iş günü) değerlendirilir.",
    ] },
    { h: "İçerik Kaldırma Talepleri", body: [
      "Haklarınızı ihlal ettiğini düşündüğünüz içerik için yukarıdaki e-posta ile başvurabilir " +
      "veya uygulama içindeki 'Bildir' aracını kullanabilirsiniz.",
    ] },
  ],
};

export const LEGAL_DOCS: Record<string, LegalDoc> = {
  [PRIVACY.slug]: PRIVACY,
  [COOKIES.slug]: COOKIES,
  [TERMS.slug]: TERMS,
  [COMMUNITY.slug]: COMMUNITY,
  [CONTACT.slug]: CONTACT,
};

export const LEGAL_SLUGS = Object.keys(LEGAL_DOCS);

export function getLegalDoc(slug: string): LegalDoc | null {
  return LEGAL_DOCS[String(slug || "").replace(/^\/+|\/+$/g, "")] || null;
}
